import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { createUrl } from '@doda/common/src/utils/urlUtil';
import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';
import { ORDER_OPTIONS, PATH_NAME_ACTION } from '../constants';

/**
 * ソートURLを生成する関数
 * @param {string} value - 表示方法
 * @param {boolean} isStaticUrl - 静的URLを使用するかどうか
 * @param {Record<string, string>} queryParams - クエリパラメータ
 * @param {string} removedUrlForSort - ソート用に加工されたURL
 * @param {Record<string, string>} orderAdditionalParam - 追加の順序パラメータ
 * @param {string} pathname - 現在のページのパス
 * @returns {string} 生成されたソートURL
 */
export const createSortUrl = (
  value: string,
  isStaticUrl: boolean,
  queryParams: Record<string, string>,
  removedUrlForSort: string,
  orderAdditionalParam: Record<string, string>,
  pathname: string
): string => {
  if (isStaticUrl) {
    const url = createUrl({
      href: makeStaticUrl(
        {
          ...queryParams,
          [QUERY_PARAMS.ds]: value,
          [QUERY_PARAMS.usrclk]: undefined,
          [QUERY_PARAMS.usrclk_searchList]: undefined,
          [QUERY_PARAMS.prsrt]: undefined,
          [QUERY_PARAMS.page]: undefined,
        },
        pathname + PATH_NAME_ACTION
      ),
      params: {
        ...orderAdditionalParam,
        usrclk_searchList: orderAdditionalParam.usrclk_searchList
          ? `${orderAdditionalParam.usrclk_searchList}_${value === '1' ? ORDER_OPTIONS.newArrival : ORDER_OPTIONS.deadline}`
          : null,
      },
    });

    // 末尾が「?」で終わる場合は「?」を消す
    return url.at(-1)?.includes('?') ? url.replace('?', '') : url;
  }

  return createUrl({
    href: createUrl({ href: removedUrlForSort, params: { ds: value } }),
    params: {
      ...orderAdditionalParam,
      usrclk_searchList: orderAdditionalParam.usrclk_searchList
        ? `${orderAdditionalParam.usrclk_searchList}_${value === '1' ? ORDER_OPTIONS.newArrival : ORDER_OPTIONS.deadline}`
        : null,
    },
  });
};
